import { render, staticRenderFns } from "./SwapConfirmationModal.vue?vue&type=template&id=7a22e4b6&scoped=true&"
import script from "./SwapConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./SwapConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./SwapConfirmationModal.vue?vue&type=style&index=0&id=7a22e4b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a22e4b6",
  null
  
)

export default component.exports